import { render } from "./ShiftSlot.vue?vue&type=template&id=57c1b6e3&scoped=true"
import script from "./ShiftSlot.vue?vue&type=script&lang=js"
export * from "./ShiftSlot.vue?vue&type=script&lang=js"

import "./ShiftSlot.vue?vue&type=style&index=0&id=57c1b6e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c1b6e3"]])

export default __exports__